// MST
import { types, flow, cast } from 'mobx-state-tree'

// Interfaces
import { ISetSelfAssessmentFormGetFormListDropdownAttrs } from 'interfaces/back-office/set-self-assessment-form/set-self-assessment-form-view.interface'
import { ISetSelfAssessmentFormApiGetListDropdownResponse } from 'interfaces/back-office/set-self-assessment-form/set-self-assessment-form-api.interface'
import { ISetSelfAssessmentFormListDropdown } from 'interfaces/back-office/set-self-assessment-form'

// Extensions
import { withEnvironment } from 'models/extensions/with-environment'
import { withHelper_baseResponseDropdownTypesModel } from 'models/extensions/with-helper'

const SetSelfAssessmentFormStoreModel = types
  .model('SetSelfAssessmentForm')
  .props({
    // LIST
    setSelfAssessmentForm_isListLoading: types.optional(types.boolean, false),
    setSelfAssessmentForm_dropdown: withHelper_baseResponseDropdownTypesModel('SetSelfAssessmentFormDropdown'),
  })
  .actions(self => ({
    // LIST
    setSelfAssessmentForm_SET_LIST_LOADING: (payload: boolean): void => {
      self.setSelfAssessmentForm_isListLoading = payload
    },
    setSelfAssessmentForm_SET_DROPDOWN: (payload: ISetSelfAssessmentFormListDropdown[]): void => {
      self.setSelfAssessmentForm_dropdown = cast(payload.filter(result => result.value))
    },
    setSelfAssessmentForm_CLEAR_DROPDOWN: (): void => {
      self.setSelfAssessmentForm_dropdown = cast([])
    },
  }))
  .extend(withEnvironment)
  .actions(self => ({
    /**
     * @description Get form list dropdown
     *
     * @param {ISetSelfAssessmentFormGetFormListDropdownAttrs} payload
     *
     * @return {any} any
     */
    setSelfAssessmentForm_fetchDropdown: flow(function* (payload: ISetSelfAssessmentFormGetFormListDropdownAttrs) {
      self.setSelfAssessmentForm_SET_LIST_LOADING(true)

      const response: ISetSelfAssessmentFormApiGetListDropdownResponse =
        yield self.environment.setSelfAssessmentFormApi.setSelfAssessmentForm_getDropdown({
          requestConfig: { ...payload.requestConfig },
        })
      if (response.ok) {
        self.setSelfAssessmentForm_SET_DROPDOWN(response.res.data)
        // Do when response is success
        if (payload?.onSuccess) payload.onSuccess()
      }

      if (!response.ok) {
        // Do when response failed
        if (payload?.onError) payload.onError()
      }

      self.setSelfAssessmentForm_SET_LIST_LOADING(false)
    }),
  }))

export const createSetSelfAssessmentFormStoreDefaultModel = () => types.optional(SetSelfAssessmentFormStoreModel, {})
